<template>
  <div class="banner-video-container" :style="bannerWrapStyle">
    <video-player
      class="video-player vjs-custom-skin"
      ref="videoPlayer"
      :playsinline="true"
      :options="playerOptions"
      @pause="onPlayerPause($event)"
      @play="onPlayerPlay($event)"
    >
    </video-player>
    <div class="video-mask" v-if="isPlay" @click="onPause"></div>
    <div class="mask-bg" @click="onPlayerClick" v-else>
      <div class="btn-play-box">
        <img class="play-btn" :src="playBtn" alt="">
      </div>
    </div>
  </div>
</template>
<script>
import "video.js/dist/video-js.css";
import { videoPlayer } from "vue-video-player";
import playBtn from '../../asset/images/play-btn.png';
export default {
  name: "videoBanner",
  props: {
    data: {
      type: Object,
    },
    videoUrl: {
      type: String
    },
   bannerVideoCover: {
          type: String
    },
    bannerWrap:{
      type: String
    }
  },
  components: {
    videoPlayer
  },
  data() {
    return {
      bannerWrapS:this.bannerWrap,
      playBtn,
      isPlay: false,
      playerOptions: {
        controls: false,
        //播放速度
        // playbackRates: [0.5, 1.0, 1.5, 2.0],
        //如果true,浏览器准备好时开始回放。
        autoplay: false,
        // 默认情况下将会消除任何音频。
        muted: false,
        // 导致视频一结束就重新开始。
        loop: true,
        // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        preload: "auto",
        language: "zh-CN",
        // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        aspectRatio: "4:3",
        // 当true时，Video.js player将拥有流体大小。换句话说,它将按比例缩放以适应其容器。
        fluid: true,
        sources: [
          {
            //类型
            type: "video/mp4",
            //url地址
            src: this.videoUrl?this.videoUrl:'',
          },
        ],
        //你的封面地址
        poster: this.bannerVideoCover,
        // poster: '',
        //允许覆盖Video.js无法播放媒体源时显示的默认信息。
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        // controlBar: {
        //   timeDivider: false,
        //   durationDisplay: false,
        //   remainingTimeDisplay: false,
        //   //全屏按钮
        //   fullscreenToggle: false,
        // }
      },
    };
  },

  watch:{
    videoUrl(val){
      if(val){
        this.$forceUpdate()
        console.log('valvalvalval',val)
      }
    }
  },

  computed: {
    player() {
      const videoPlayer = this.$refs.videoPlayer;
      return videoPlayer.player;
    },
    bannerWrapStyle(){
      return {
        width: `${this.bannerWrapS==1 ? '351px' : '100%'}`,
      }
    }
  },
  methods: {
    onPlayerPause() {
      this.isPlay = false;
      this.player.pause();
    },
    onPlayerPlay() {
      this.isPlay = true;
      this.player.play();
    },
    onPlayerClick() {
      if (this.isPlay) {
        this.player.pause();
      } else {
        this.player.play();
      }
    },
    onPause(){
      this.isPlay = false;
      this.player.pause();
    }
  },
  mounted() {
    console.log(this.videoUrl,'this.videoUrl000000')
  },
};
</script>
<style lang="less" scoped>
.banner-video-container {
  position: relative;
  height: 560px;
  text-align: center;
  line-height: 100px;
  border: 1px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  position: relative;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  margin: 0 auto;
  // /deep/.video-player {
  //   .vjs-big-play-button {
  //     .vjs-icon-placeholder:before {
  //       font-size: 88px;
  //     }
  //   }
  // }
  .video-mask{
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    z-index: 99999;
  }
  .btn-play-box{
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    background: rgba(0, 0, 0, 0.5);
    width: 128px;
    height: 128px;
    left: 50%;
    top: 50%;
    margin-left: -64px;
    margin-top: -64px;
    border-radius: 50%;
  }
  .mask-bg {
    position: absolute;
    width: 128px;
    height: 128px;
    left: 50%;
    top: 50%;
    margin-left: -64px;
    margin-top: -64px;
    border-radius: 50%;
    .play-btn{
      width: 128px;
      height: 128px;
    }
    // .mask-bg-btn {
    //   position: relative;
    //   background-color: #fff;
    // }
    // .mask-bg-btn:before,
    // .mask-bg-btn:after {
    //   content: "";
    //   position: absolute;
    //   background-color: inherit;
    // }
    // .mask-bg-btn,
    // .mask-bg-btn:before,
    // .mask-bg-btn:after {
    //   width: 38px;
    //   height: 38px;
    //   border-radius: 0 20px 0 60px;
    // }
    // .mask-bg-btn {
    //   transform: rotate(30deg) skewX(-30deg) scale(1, 0.866);
    // }
    // .mask-bg-btn:before {
    //   transform: rotate(-135deg) skewX(-45deg) scale(1.414, 0.707)
    //     translate(0, -50%);
    // }
    // .mask-bg-btn:after {
    //   transform: rotate(135deg) skewY(-45deg) scale(0.707, 1.414) translate(50%, 50%);
    // }
  }
  // /deep/.video-js:hover .vjs-big-play-button,
  // /deep/.vjs-custom-skin > .video-js .vjs-big-play-button:focus,
  // /deep/.vjs-custom-skin > .video-js .vjs-big-play-button:active {
  //   background-color: rgba(0, 0, 0, 0.5);
  // }



    /deep/ .vjs-poster {
        background-size: cover!important;
    }


  /deep/.vjs-custom-skin > .video-js .vjs-big-play-button {
    display: none!important;
    // font-size: 3.5em;
    // width: 128px !important;
    // height: 128px !important;
    // line-height: 128px !important;
    // border-radius: 50%;
    // margin-top: -64px !important;
    // margin-left: -64px !important;
    // border: none;
  }
}
</style>
